
<app-generic-header [goBack] = dismiss.bind(this) variant="transparent"></app-generic-header>

<ion-content class="ion-padding" (swipe)="swipeEvent($event)" id="contentDiv">

  <div class="badgeContainer">
    <div class="titleBadge">
      <div class="imgDiv">
        <img src="assets/imgs/orangeStar.svg" alt="Super Like Logo">
      </div>
    </div>
  </div>

  <div class="frameDiv">
    <div class="mainDiv">

      <div class="internalContent">
        <div class="sendSuperLike">
          {{'superLikeMsg' | translate}}
        </div>

        <div class="picDiv">
          <img class="pic" src="{{theSoul.firstPic}}">
        </div>

        <div class="intro">
            {{'addMessageTo' | translate}} {{soulName}}
        </div>

        <div class="addInstruction">
          <p >{{'youMayAddMsg' | translate}}</p>
        </div>

        <div class="tipDiv">
          {{'tipMentionProfile' | translate}}
        </div>


        <div class="blankSpace">
          
        </div>

        <div class="messageInput">
          <form [formGroup]="myForm">

            <ion-item lines="none">
                <ion-label position="floating">{{'message' | translate}}:</ion-label>
                <ion-textarea autoGrow="true" rows="3" autocomplete="on" autocorrect="on" formControlName="msgControl" ></ion-textarea>
            </ion-item>
          </form>
        </div>
        <div class="charsLeftContainer{{getCharStatus()}}">
          <p align="right">{{getCharsLeft()}} {{'left' | translate}}</p>
        </div>
        


      </div>
      <div class="buttons">
        <ion-grid>
          <ion-row>
            <ion-col size="6">
                <ion-button class="cancelBtn" shape="round" expand="full" (click)="dismiss()" block>{{'cancel' | translate}}</ion-button>
            </ion-col>
            
            <ion-col size="6"> 
                <ion-button shape="round" expand="full" color="primary" (click)="send()" block>{{'send' | translate}}</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>

</ion-content>
